export default function DetailProductSeceleton() {
  return (
    <div className='flex flex-col gap-4 w-full'>
      <div className='flex h-[40px] w-[40%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
      <div className='flex items-center gap-4'>
        <div className='flex h-[40px] w-[40px] animate-pulse bg-greyscaleGON-200 object-cover'></div>
        <div className='flex h-[40px] w-[40px] animate-pulse bg-greyscaleGON-200 object-cover'></div>
        <div className='flex h-[40px] w-[40px] animate-pulse bg-greyscaleGON-200 object-cover'></div>
      </div>

      <div className='flex h-[60px] w-full gap-4 bg-greyscaleGON-50 p-4'>
        <div className='flex h-full w-[40%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
        <div className='flex h-full w-[40px] animate-pulse bg-greyscaleGON-200 object-cover'></div>
      </div>

      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-2'>
          <div className='flex h-[10px] w-[10%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
          <div className='flex gap-2'>
            <div className='flex h-[40px] w-[20%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
            <div className='flex h-[40px] w-[20%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
            <div className='flex h-[40px] w-[20%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
          </div>
        </div>
        <div className='flex flex-col gap-2'>
          <div className='flex h-[10px] w-[10%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
          <div className='flex gap-2'>
            <div className='flex h-[40px] w-[15%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
            <div className='flex h-[40px] w-[15%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
            <div className='flex h-[40px] w-[15%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
          </div>
        </div>
      </div>

      <div className='flex flex-col gap-2'>
        <div className='flex h-[10px] w-[10%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
        <div className='flex h-[50px] w-[20%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
      </div>

      <div className='flex flex-col gap-2'>
        <div className='flex h-[10px] w-[10%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
        <div className='flex h-[50px] w-[20%] animate-pulse bg-greyscaleGON-200 object-cover'></div>
      </div>

      <div className='flex flex-col gap-2 sm:flex-row'>
        <div className='flex h-[40px] w-full animate-pulse bg-greyscaleGON-200 object-cover'></div>
        <div className='flex h-[40px] w-full animate-pulse bg-greyscaleGON-200 object-cover'></div>
      </div>
    </div>
  );
}
